import { CSS as ModalCSS } from '../../components/modal/modal.style';
import { DefaultTheme } from '../../components/theme';

const MODAL_WIDTH = '640px';
const MODAL_HEIGHT = '600px';

export const CSS = {
	modal: 'c-VerifyMixedFormsModal',
	jobName: 'c-VerifyMixedFormsModal__JobName',
	intro: 'c-VerifyMixedFormsModal__Intro',
	section: 'c-VerifyMixedFormsModal__Section',
	sectionDescription: 'c-VerifyMixedFormsModal__SectionDescription',
	formGroup: 'c-VerifyMixedFormsModal__FormGroup',
	versionGroup: 'c-VerifyMixedFormsModal__VersionGroup',
	versionLabel: 'c-VerifyMixedFormsModal__VersionLabel',
	poleList: 'c-VerifyMixedFormsModal__PoleList',
	restOn: 'c-VerifyMixedFormsModal__RestOn',
};

export const Style = {
	// Fixed size so expanding/collapsing sections scrolls the content instead of resizing the modal.
	[`.${ModalCSS.modal}.${CSS.modal}`]: {
		width: MODAL_WIDTH,
		height: MODAL_HEIGHT,
	},
	[CSS.jobName]: {
		color: DefaultTheme.font.color.supporting,
		'margin-bottom': DefaultTheme.space(3),
	},
	[CSS.intro]: {
		'margin-bottom': DefaultTheme.space(4),
	},
	[CSS.section]: {
		'margin-bottom': DefaultTheme.space(3),
		'&:last-child': {
			'margin-bottom': 0,
		},
	},
	[CSS.sectionDescription]: {
		color: DefaultTheme.font.color.supporting,
		margin: `0 0 ${DefaultTheme.space(3)} 0`,
	},
	[CSS.formGroup]: {
		'margin-bottom': DefaultTheme.space(2),
		'&:last-child': {
			'margin-bottom': 0,
		},
	},
	[CSS.versionGroup]: {
		'margin-bottom': DefaultTheme.space(3),
		'&:last-child': {
			'margin-bottom': 0,
		},
	},
	[CSS.versionLabel]: {
		'font-weight': DefaultTheme.font.weight.bold,
		color: DefaultTheme.font.color.supporting,
		'margin-bottom': DefaultTheme.space(1),
	},
	[CSS.poleList]: {
		'list-style': 'none',
		margin: 0,
		padding: 0,
	},
	[CSS.restOn]: {
		color: DefaultTheme.font.color.supporting,
	},
};
